import EllipseButton from "../../Buttons/EllipseButton/EllipseButton";
import classes from "./PageHeader.module.css";

const PageHeader = (props) => {

  return (
    <div className={classes.pageHeader}>
      <div className={classes.tableHeader}>
        <img src={props.icon} className={classes.icon} />
        <div className={props.isDisableNeeded ? [classes.titleContainer, classes.disable].join(' ') : classes.titleContainer}>
          <div className={classes.title}>{props.pageTitle}</div>
          <div className={classes.subTitle}>{props.subTitle}</div>
        </div>
        {props.pageSecondTitle && 
          <div className={classes.tableSecondHeader}>
            <div className={classes.title}>
              <h2>{props.pageSecondTitle} {props.pageSecondTitleValue}</h2>
            </div>
          </div>
        }
      </div>
      {(props.validRole && !props.disableDisplay) &&(
        <EllipseButton onClick={props.handleModalOpen}>{props.buttonText}</EllipseButton>
      )}
    </div>
  );
};

export default PageHeader;
